

(function ($) {
    $(function () {

        if ($('#commentform').length) {
            if ($('#author').length === 0 && $('#email').length === 0) {
                $('#commentform').validate({
                    rules: {
                        comment: {
                            required: true,
                            minlength: 5
                        }
                    },
                    messages: {
                        comment: {
                            required: "Please provide a comment",
                            minlength: "Your comment must be at least 5 characters long"
                        }
                    },
                    submitHandler: function (form) {
                        form.submit();
                    }
                });
            } else {
                $('#commentform').validate({
                    rules: {
                        author: {
                            required: true,
                            minlength: 2
                        },
                        email: {
                            required: true,
                            email: true
                        },
                        comment: {
                            required: true,
                            minlength: 5
                        }
                    },
                    messages: {
                        author: {
                            required: "Please provide your name",
                            minlength: "Your name must be at least 2 characters long"
                        },
                        email: {
                            required: "Please provide your email",
                            email: "Please enter a valid email address"
                        },
                        comment: {
                            required: "Please provide a comment",
                            minlength: "Your comment must be at least 5 characters long"
                        }
                    },
                    submitHandler: function (form) {
                        form.submit();
                    }
                });
            }
        }



    });
})(jQuery);